import React from "react"
import { Link } from "react-router-dom"
import { Lightning } from "react-bootstrap-icons"
import { isMobile } from "react-device-detect"

interface VenueSearchResultProps {
  bandName: string
  bandCoverImageUrl?: string | null
  bandId: number
  bandPath: string
  bandLocation?: string | null
  bandTypeNice?: string | null
}

export const VenueSearchResult: React.FC<VenueSearchResultProps> = ({
  bandName,
  bandCoverImageUrl,
  bandId,
  bandPath,
  bandLocation,
  bandTypeNice,
}) => {
  return (
    <li className="col-span-1">
      <div>
        {bandCoverImageUrl ? (
          <div
            style={{
              backgroundColor: "black",
              backgroundImage: `url(${bandCoverImageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              aspectRatio: "16/9",
              minHeight: isMobile ? "156px" : "unset",
            }}
            className="w-full overflow-hidden"
          >
            <div
              className="w-full h-full justify-center flex items-center"
              style={{
                background: "rgb(0,0,0,0.3)",
                paddingTop: isMobile ? "36px" : "unset",
                paddingBottom: isMobile ? "36px" : "unset",
              }}
            ></div>
          </div>
        ) : (
          <div
            className="w-full bg-black flex justify-center items-center overflow-hidden"
            style={{ aspectRatio: "16/9" }}
          >
            <Lightning
              className="text-white"
              width="50%"
              height="50%"
              style={{
                paddingTop: isMobile ? "36px" : "unset",
                paddingBottom: isMobile ? "36px" : "unset",
              }}
            />
          </div>
        )}
      </div>
      <>
        <Link to={bandPath} title={bandName}>
          <div className="font-bold leading-tight text-black-800">
            {bandName}
          </div>
        </Link>
        {bandTypeNice && (
          <div className="font-medium leading-tight text-gray-600 text-xs uppercase">{bandTypeNice}</div>
        )}
        <Link to={bandPath} title={bandName}>
          <div className="text-gray-800 text-sm leading-tight">
            {bandLocation}
          </div>
        </Link>
      </>
    </li>
  )
}

export default VenueSearchResult

